import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, forwardRef, Input, Optional, Output, Self, ViewChild } from '@angular/core';
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR,
  NgControl,
  ReactiveFormsModule,
} from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { FormErrorMessageDirective } from '../../../directives/form-error-message.directive';
import { TranslateService } from '../../../../i18n/translate.service';

@Component({
  selector: 'app-input',
  imports: [CommonModule, InputTextModule, FormErrorMessageDirective],
  templateUrl: './input.html',
  styleUrl: './input.scss',
  standalone: true,
})
export class InputComponent implements ControlValueAccessor {
  @ViewChild('inputRef') inputRef!: ElementRef;

  @Input() label = '';
  @Input() secondaryLabel = '';
  @Input() placeholder = '';
  @Input() type: 'text' | 'number' | 'email' | 'password' | 'phone' = 'text';
  @Input() labelCustomClass: string = '';
  @Input() inputCustomClass: string = '';
  @Input() submitted: boolean = false;
  @Input() disabled: boolean = false;
  @Input() isReadonly: boolean = false;
  @Input() showEdit = false;
  @Input() phoneCode?: string;
  @Input() countryCode?: string;

  @Output() onEditClick = new EventEmitter<any>();

  value: any = '';

  constructor(@Optional() @Self() public ngControl: NgControl, readonly i18n: TranslateService) {
    if (this.ngControl != null) {
      this.ngControl.valueAccessor = this;
    }
  }

  private onChangeFn: (value: any) => void = () => { };
  private onTouchedFn: () => void = () => { };

  // called when input changes
  // onInput(event: Event) {
  //   const input = event.target as HTMLInputElement;
  //   this.value = input?.value ?? '';
  //   this.onChangeFn(this.value);
  // }

  onInput(event?: any) {
    let value = this.value;

    if (event?.target) {
      const input = event.target as HTMLInputElement;
      value = input.value;

      if (this.type === 'phone') {
        value = value.replace(/\D+/g, '');
        input.value = value;
      }
    }

    this.value = value;
    this.onChangeFn(this.value);
  }

  // called when input is blurred
  onTouched() {
    this.onTouchedFn();
  }

  // ControlValueAccessor methods
  writeValue(value: any): void {
    this.value = value ?? '';
  }

  registerOnChange(fn: any): void {
    this.onChangeFn = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedFn = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  makeEditable() {
    this.onEditClick.emit();
  }

  focusInput() {
    this.inputRef?.nativeElement?.focus();
  }
}
